import { createSelector, createSlice } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
    initialState: {
        isLoading: false,
        result: null,
        error: null,
    },
    name: 'notifications',
    reducers: {
        sendAdminNotification: state => {
            state.isLoading = true;
            state.error = null;
            state.result = null;
        },
        adminNotificationSent: (state, { payload }) => {
            state.isLoading = false;
            state.result = payload;
            state.error = null;
        },
        adminNotificationFailed: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload?.error || 'Failed to send notification';
        },
        resetNotificationState: state => {
            state.isLoading = false;
            state.result = null;
            state.error = null;
        },
    },
});

// Selectors
const getSelf = state => state.notifications;

export const isNotificationLoading = createSelector(
    getSelf,
    state => state.isLoading,
);

export const getNotificationResult = createSelector(
    getSelf,
    state => state.result,
);

// Export actions
export const {
    sendAdminNotification,
    adminNotificationSent,
    adminNotificationFailed,
    resetNotificationState,
} = notificationsSlice.actions;

// Export reducer
export default notificationsSlice.reducer;
